import { Grid, Stack, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import Select from '../../../generic/form/Select'
import { useGetSupplierTypesQuery } from 'services/customers'

export interface CustomerSupplierTypeMultiSelectProps {
  title: string
  subTitle: string
}

const CustomerSupplierTypeMultiSelect: React.FC<CustomerSupplierTypeMultiSelectProps> = ({ title, subTitle }) => {
  const { control, watch } = useFormContext()
  const watchSupplierTypes = watch('dispatchSettings.loadBoard.supplierTypesFilter')

  const { data: supplierTypes, isFetching: isLoadingSupplierTypes } = useGetSupplierTypesQuery({})

  const isLoading = isLoadingSupplierTypes

  const items =
    supplierTypes?.Items?.map(item => ({ id: item.id || '', name: item.name || '' })) ||
    watchSupplierTypes.map(item => ({ id: item, name: 'loading...' }))

  return (
    <Grid key="customerSupplierTypeMultiSelect" mt={2}>
      <Stack alignItems="left" direction="column">
        <Typography variant="h6" color="textPrimary" data-testid="title">
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary" data-testid="subtitle" sx={{ mb: 2 }}>
          {subTitle}
        </Typography>
        <Select
          label="Supplier Types"
          disabled={isLoading}
          name="dispatchSettings.loadBoard.supplierTypesFilter"
          control={control}
          items={items}
          defaultValue={[]}
          sx={{}}
          selectProps={{ multiple: true, sx: { width: '400px' } }}
          useChips
        />
      </Stack>
    </Grid>
  )
}

export default CustomerSupplierTypeMultiSelect
